import { getTeamsState } from '../selectors';

export const getTeamJurisdictionsState = state =>
    getTeamsState(state).jurisdictions;

export const getTeamJurisdiction = state =>
    getTeamJurisdictionsState(state).jurisdiction;
export const getTeamAddJurisdictionLoading = state =>
    getTeamJurisdiction(state).add.loading;

export const getTeamBrand = state => getTeamJurisdictionsState(state).brand;
export const getTeamAddBrandLoading = state => getTeamBrand(state).add.loading;
